module.exports = __webpack_public_path__ + "media/images/lb/150-7fb10dd9ee98c6dfc492c52833efe2ef.svg";